import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { ChallengeManager } from "../ChallengeManager";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";

export class ChallengeGUI extends Phaser.Group {

    private backButton: Phaser.Button;
    private hintButton: Phaser.Button;

    constructor(game: Phaser.Game) {

        super(game, null, "challenge-gui");

        this.backButton = new Phaser.Button( this.game, 10, 10, "texture_atlas_1", this.onClickBack, this);
        this.backButton.setFrames("button_menu_on.png", "button_menu_off.png", "button_menu_on.png");
        this.backButton.forceOut = true;
        this.backButton.scale.y = GameVars.scaleY;
        this.add(this.backButton);

        this.hintButton = new Phaser.Button( this.game, GameConstants.GAME_WIDTH - 10, 558 - (380 * GameVars.scaleY), "texture_atlas_1", this.onClickHint, this);
        this.hintButton.setFrames("button_hint_plain_on.png", "button_hint_plain.png", "button_hint_plain_on.png");
        this.hintButton.forceOut = true;
        this.hintButton.anchor.set(1);
        this.hintButton.scale.y = GameVars.scaleY;
        this.add(this.hintButton);
    }

    public removeHint(): void {

        this.hintButton.visible = false;
    }

    public disableHint(): void {

        this.hintButton.inputEnabled = false;
        this.hintButton.alpha = .5;
    }

    public enableHint(): void {

        this.hintButton.inputEnabled = true;
        this.hintButton.alpha = 1;
    }

    private onClickBack(): void {

        AudioManager.playSound("click"); 

        AudioManager.setMusicVolume(1);

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "ProblemsMenu";
            } else {
                GameManager.enterProblemSelectionState(GameVars.puzzleMoves);
            }
        } else {
            GameManager.enterProblemSelectionState(GameVars.puzzleMoves);
        } 
    }

    private onClickHint(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (gdsdk !== 'undefined' && gdsdk.showAd !== 'undefined') {
                gdsdk.showAd('rewarded');
                GameVars.typeAd = "Hint";
            } else {
                ChallengeManager.useHint();
            }
        } else {
            ChallengeManager.useHint();
        }

        AudioManager.playSound("click"); 
    }
}
